/** Recordatorio de tareas no leídas (auxiliares) — helpers puros. */

/** Intervalo entre avisos si el auxiliar no confirma lectura. */
export const UNREAD_TASKS_REMINDER_MS = 2 * 60 * 60 * 1000;
/**
 * Revisión frecuente: un setInterval(2h) se desalinea y los navegadores
 * lo aplazan mucho en pestañas en segundo plano.
 */
export const UNREAD_TASKS_POLL_MS = 30 * 1000;

const STORAGE_KEY_PREFIX = "visor:assigned-tasks-unread-prompt-at:";

export function storageKeyForUser(userId) {
  return `${STORAGE_KEY_PREFIX}${userId || "anon"}`;
}

export function readLastPromptAt(userId) {
  try {
    const raw = localStorage.getItem(storageKeyForUser(userId));
    const n = Number(raw || 0);
    return Number.isFinite(n) ? n : 0;
  } catch {
    return 0;
  }
}

export function writeLastPromptAt(userId, ts = Date.now()) {
  try {
    localStorage.setItem(storageKeyForUser(userId), String(ts));
  } catch {
    /* ignore */
  }
}

/**
 * ¿Toca mostrar el aviso?
 * - force: entrada a sesión (o primer montaje).
 * - si no: solo cuando pasaron ≥ 2 h desde el último aviso mostrado.
 * No reescribe el reloj al cerrar sin leer (evita saltarse el ciclo de 2 h).
 */
export function shouldShowUnreadTasksPrompt({
  hasUnread,
  isAlreadyOpen,
  force = false,
  lastPromptAt = 0,
  now = Date.now(),
  intervalMs = UNREAD_TASKS_REMINDER_MS,
} = {}) {
  if (!hasUnread || isAlreadyOpen) return false;
  if (force) return true;
  if (!lastPromptAt || lastPromptAt <= 0) return true;
  return now - lastPromptAt >= intervalMs;
}
